<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
@for (modal of modals; track modal) {
<div class="modal__backdrop" animate.enter="modal-backdrop-enter" animate.leave="modal-backdrop-leave" [style.zIndex]="modal.options.zIndex || 1000"
  (click)="onBackdropClick(modal, $event)">
  <div class="modal__container" animate.enter="modal-container-enter" animate.leave="modal-container-leave" [ngClass]="[
           'modal__container--' + (modal.options.size || 'md'),
           modal.options.customClass || ''
         ]" (click)="$event.stopPropagation()">
    @if (resolveText(modal.options.title)) {
    <div class="modal__header">
      <h2 class="modal__title">{{ resolveText(modal.options.title) }}</h2>
      @if (modal.options.closable) {
      <button class="modal__close" (click)="closeModal(modal)">
        <i class="material-icons">close</i>
      </button>
      }
    </div>
    }
    <div class="modal__body" [ngClass]="{'modal__body--with-icon': shouldShowIcon(modal)}">
      @if (shouldShowIcon(modal)) {
      <div class="modal__icon" [ngClass]="getIconClass(modal.options.type)">
        <i class="material-icons">{{ getIconName(modal.options.type) }}</i>
      </div>
      }
      <div class="modal__content">
        @if (resolveText(modal.options.message)) {
        <p class="modal__message">{{ resolveText(modal.options.message) }}</p>
        }
        @if (modal.options.type === ModalType.FORM && forms.get(modal.id)) {
        <form [formGroup]="forms.get(modal.id)!" (ngSubmit)="submitForm(modal)">
          @for (field of modal.options.formFields; track field) {
          <div class="modal__form-field" [id]="'field_' + modal.id + '_container_' + field.name"
            [ngClass]="{'modal__field--hidden': !shouldFieldBeVisible(modal, field) || field.hidden}">
            <label [for]="'field_' + modal.id + '_' + field.name" class="modal__label">
              {{ resolveText(field.label) || field.name }}
              @if (field.required) {
              <span class="modal__required">*</span>
              }
            </label>
            @if (field.type === 'text') {
            <input [type]="'text'" [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name"
              [placeholder]="resolveText(field.placeholder)"
              [attr.maxlength]="field.maxLength !== undefined ? field.maxLength : null" [ngClass]="[
                            'modal__input',
                            field.class || '',
                            getErrorMessage(modal, field.name) ? 'modal__input--error' : ''
                        ]">
            }
            @if (field.type === 'password') {
            <input type="password" [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name"
              [placeholder]="resolveText(field.placeholder)" [attr.maxlength]="getAttributeValue(field.maxLength)" [ngClass]="[
    'modal__input',
    field.class || '',
    getErrorMessage(modal, field.name) ? 'modal__input--error' : ''
]">
            }
            @if (field.type === 'time') {
            <input type="time" [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name"
              [placeholder]="resolveText(field.placeholder)" [ngClass]="[
    'modal__input',
    field.class || '',
    getErrorMessage(modal, field.name) ? 'modal__input--error' : ''
  ]">
            }
            @if (field.type === 'email') {
            <input type="email" [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name"
              [placeholder]="resolveText(field.placeholder)" [attr.maxlength]="getAttributeValue(field.maxLength)" [ngClass]="[
        'modal__input',
        field.class || '',
        getErrorMessage(modal, field.name) ? 'modal__input--error' : ''
    ]">
            }
            @if (field.type === 'number') {
            <input type="text" [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name"
              [placeholder]="resolveText(field.placeholder)" pattern="^-?\d+(\.\d+)?$" [attr.min]="field.min"
              [attr.max]="field.max" (keypress)="onNumberKeyPress($event, field)" [ngClass]="[
        'modal__input',
        field.class || '',
        getErrorMessage(modal, field.name) ? 'modal__input--error' : ''
    ]">
            }
            @if (field.type === 'textarea') {
            <textarea [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name"
              [placeholder]="resolveText(field.placeholder)" [attr.maxlength]="getAttributeValue(field.maxLength)" [ngClass]="[
    'modal__textarea',
    field.class || '',
    getErrorMessage(modal, field.name) ? 'modal__textarea--error' : ''
]"></textarea>
            }
            @if (field.type === 'select') {
            <select [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name" [ngClass]="[
                        'modal__select',
                        field.class || '',
                        getErrorMessage(modal, field.name) ? 'modal__select--error' : ''
                      ]">
              @if (resolveText(field.placeholder)) {
              <option value="" disabled selected>{{ resolveText(field.placeholder) }}
              </option>
              }
              @for (option of field.options; track option) {
              <option [value]="option.value">
                {{ option.label }}
              </option>
              }
            </select>
            }
            @if (field.type === 'multiselect') {
            <app-multi-select [id]="'field_' + modal.id + '_' + field.name" [options]="field.options || []"
              [selectedValues]="getMultiSelectValues(modal, field)"
              [multiple]="field.multiple ?? true"
              [placeholder]="resolveText(field.placeholder)"
              (selectionChange)="onMultiSelectChange(modal, field.name, $event)" [class]="[
                              'modal__ng-select',
                              field.class || '',
                              getErrorMessage(modal, field.name) ? 'modal__ng-select--error' : ''
                            ]">
            </app-multi-select>
            }
            @if (field.type === 'checkboxlist') {
            <div class="modal__checkboxlist">
              @for (option of field.options; track option) {
              <div class="modal__checkboxlist-group">
                <div class="modal__checkboxlist-item">
                  <input type="checkbox"
                    [id]="'field_' + modal.id + '_' + field.name + '_' + option.value"
                    [checked]="isCheckboxListOptionSelected(modal, field.name, option.value)"
                    (change)="onCheckboxListChange(modal, field.name, option, $event)"
                    class="modal__checkboxlist-checkbox">
                  <label [for]="'field_' + modal.id + '_' + field.name + '_' + option.value"
                    class="modal__checkboxlist-label">
                    {{ option.label }}
                  </label>
                </div>
                @if (option.children && isCheckboxListOptionSelected(modal, field.name, option.value)) {
                <div class="modal__checkboxlist-children">
                  @for (child of option.children.options; track child) {
                  <div class="modal__checkboxlist-item">
                    <input type="checkbox"
                      [id]="'field_' + modal.id + '_' + option.children.fieldName + '_' + child.value"
                      [checked]="isCheckboxListOptionSelected(modal, option.children.fieldName, child.value)"
                      (change)="onCheckboxListChange(modal, option.children.fieldName, child, $event)"
                      class="modal__checkboxlist-checkbox">
                    <label [for]="'field_' + modal.id + '_' + option.children.fieldName + '_' + child.value"
                      class="modal__checkboxlist-label">
                      {{ child.label }}
                    </label>
                  </div>
                  }
                </div>
                }
              </div>
              }
            </div>
            }
            @if (field.type === 'checkbox') {
            <div class="modal__checkbox-container">
              <input [type]="'checkbox'" [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name"
                class="modal__checkbox">
              <label [for]="'field_' + modal.id + '_' + field.name" class="modal__checkbox-label">
                {{ resolveText(field.placeholder) }}
              </label>
            </div>
            }
            @if (field.type === 'radio') {
            <div class="modal__radio-group">
              @for (option of field.options; track option; let i = $index) {
              <div class="modal__radio-container">
                <input [type]="'radio'" [id]="'field_' + modal.id + '_' + field.name + '_' + i"
                  [formControlName]="field.name" [value]="option.value" class="modal__radio">
                <label [for]="'field_' + modal.id + '_' + field.name + '_' + i" class="modal__radio-label">
                  {{ option.label }}
                </label>
              </div>
              }
            </div>
            }
            @if (field.type === 'date') {
            <input [type]="'date'" [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name"
              [ngClass]="[
                       'modal__date',
                       field.class || '',
                       getErrorMessage(modal, field.name) ? 'modal__date--error' : ''
                     ]">
            }
            @if (getErrorMessage(modal, field.name)) {
            <div class="modal__error">
              {{ getErrorMessage(modal, field.name) }}
            </div>
            }
          </div>
          }
        </form>
        }
        @if (modal.options.type === ModalType.PASSWORD_CHANGE && forms.get(modal.id)) {
        <div class="modal__password-change">
          <form [formGroup]="forms.get(modal.id)!" (ngSubmit)="submitForm(modal)">
            @for (field of modal.options.formFields; track field) {
            <div class="modal__form-field">
              <label [for]="'field_' + modal.id + '_' + field.name" class="modal__label">
                {{ resolveText(field.label) }}
                @if (field.required) {
                <span class="modal__required">*</span>
                }
              </label>
              <div class="modal__password-field">
                <input [type]="isPasswordVisible(modal.id, field.name) ? 'text' : 'password'"
                  [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name"
                  [placeholder]="resolveText(field.placeholder)" autocomplete="new-password" [ngClass]="[
            'modal__input',
            field.class || '',
            getErrorMessage(modal, field.name) ? 'modal__input--error' : ''
          ]">
                <button type="button" class="modal__password-toggle-btn"
                  (click)="togglePasswordVisibility(modal.id, field.name)"
                  [attr.aria-label]="isPasswordVisible(modal.id, field.name) ? (translateData?.hide_password || 'Hide password') : (translateData?.show_password || 'Show password')">
                  <img
                    [src]="isPasswordVisible(modal.id, field.name) ? 'assets/icons/eye-open.svg' : 'assets/icons/eye-closed.svg'"
                    [alt]="isPasswordVisible(modal.id, field.name) ? (translateData?.hide_password || 'Hide password') : (translateData?.show_password || 'Show password')"
                    class="black-filter">
                </button>
              </div>
              @if (field.name === 'newPassword' && modal.options.data?.showRequirements) {
              <div class="modal__password-requirements">
                <div class="modal__requirements-list">
                  @for (requirement of getPasswordCriteria(modal.options.data?.password || ''); track requirement) {
                  <div class="modal__requirement-item" [class.modal__requirement-met]="requirement.met"
                    [class.modal__requirement-unmet]="!requirement.met">
                    <div class="modal__requirement-icon">
                      @if (requirement.met) {
                      <span class="modal__check-icon">✓</span>
                      }
                      @if (!requirement.met) {
                      <span class="modal__cross-icon">✕</span>
                      }
                    </div>
                    <span class="modal__requirement-text">{{ requirement.text }}</span>
                  </div>
                  }
                </div>
              </div>
              }
              @if (getErrorMessage(modal, field.name)) {
              <div class="modal__error">
                {{ getErrorMessage(modal, field.name) }}
              </div>
              }
            </div>
            }
          </form>
        </div>
        }
        @if (modal.options.type === ModalType.CUSTOM) {
        <div class="modal__custom-component">
          @if (modal.options.data?.isImagePreview) {
          <div class="modal__image-preview">
            <div class="modal__image-container">
              <img [src]="modal.options.data.imageUrl" [alt]="resolveText(modal.options.title) || 'Image preview'"
                class="modal__image-preview-img">
            </div>
            @if (modal.options.data?.showDownload) {
            <div class="modal__image-actions">
              <button class="modal__download-btn"
                (click)="downloadImage(modal.options.data.imageUrl, modal.options.data.downloadFilename)">
                <i class="material-icons">download</i>
                {{ translateData?.download_image || 'Download Image' }}
              </button>
            </div>
            }
          </div>
          } @else if (modal.options.component) {
          <ng-container *ngComponentOutlet="modal.options.component; inputs: modal.options.data"></ng-container>
          }
        </div>
        }
        @if (modal.options.type === ModalType.PICTURE_UPLOAD) {
        <div class="modal__picture-upload">
          @if (!modal.options.data?.imageUrl) {
          <div class="modal__picture-input-wrapper">
            <div class="modal__picture-dropzone"
              [class.modal__picture-dropzone--active]="dragOverModalId === modal.id"
              (dragover)="onDropzoneDragOver($event)"
              (dragenter)="onDropzoneDragEnter($event, modal.id)"
              (dragleave)="onDropzoneDragLeave($event, modal.id)"
              (drop)="onDropFile($event, modal)">
              <input type="file" id="picture-upload-{{modal.id}}" [accept]="modal.options.data?.fileTypes || 'image/*'"
                (change)="onImageFileSelected($event, modal)" class="modal__picture-input">
              <label for="picture-upload-{{modal.id}}" class="modal__picture-input-label">
                <i class="material-icons">cloud_upload</i>
                <span>{{ translateData?.picture_upload_drag_drop || 'Drag & drop or click to upload' }}</span>
                <small>{{ translateData?.picture_upload_max_size || 'Max size:' }} {{(modal.options.data?.maxFileSize || 5242880) /
                  1048576}}MB</small>
              </label>
            </div>
          </div>
          }
          @if (modal.options.data?.imageUrl) {
          <div class="modal__picture-editor">
            <div class="modal__picture-toolbar">
              @if (modal.options.data?.cropControls) {
              <div class="modal__picture-aspect-ratio">
                <button class="modal__picture-tool-button"
                  [class.modal__picture-tool-button--active]="modal.options.data?.cropRatio === 'free'"
                  (click)="setCropRatio('free', modal)" [title]="translateData?.crop_ratio_free || 'Free aspect ratio'">
                  <i class="material-icons">crop_free</i>
                </button>
                <button class="modal__picture-tool-button"
                  [class.modal__picture-tool-button--active]="modal.options.data?.cropRatio === 'square'"
                  (click)="setCropRatio('square', modal)" [title]="translateData?.crop_ratio_square || 'Square (1:1)'">
                  <i class="material-icons">crop_square</i>
                </button>
                <button class="modal__picture-tool-button"
                  [class.modal__picture-tool-button--active]="modal.options.data?.cropRatio === '4:3'"
                  (click)="setCropRatio('4:3', modal)" [title]="translateData?.crop_ratio_4_3 || '4:3 aspect ratio'">
                  <span>4:3</span>
                </button>
                <button class="modal__picture-tool-button"
                  [class.modal__picture-tool-button--active]="modal.options.data?.cropRatio === '16:9'"
                  (click)="setCropRatio('16:9', modal)" [title]="translateData?.crop_ratio_16_9 || '16:9 aspect ratio'">
                  <span>16:9</span>
                </button>
              </div>
              }
              @if (modal.options.data?.rotateControls) {
              <div class="modal__picture-rotate">
                <button class="modal__picture-tool-button" (click)="rotateImage(modal, -90)" [title]="translateData?.rotate_left || 'Rotate left'">
                  <i class="material-icons">rotate_left</i>
                </button>
                <button class="modal__picture-tool-button" (click)="rotateImage(modal, 90)" [title]="translateData?.rotate_right || 'Rotate right'">
                  <i class="material-icons">rotate_right</i>
                </button>
              </div>
              }
              @if (modal.options.data?.zoomControls) {
              <div class="modal__picture-zoom">
                <button class="modal__picture-tool-button" (click)="adjustZoom(modal, 0.9)" [title]="translateData?.zoom_out || 'Zoom out'">
                  <i class="material-icons">zoom_out</i>
                </button>
                <button class="modal__picture-tool-button" (click)="adjustZoom(modal, 1.1)" [title]="translateData?.zoom_in || 'Zoom in'">
                  <i class="material-icons">zoom_in</i>
                </button>
              </div>
              }
              @if (modal.options.data?.resetButton) {
              <div class="modal__picture-reset">
                <button class="modal__picture-tool-button modal__picture-tool-button--reset" (click)="resetCrop(modal)"
                  [title]="translateData?.reset_all_changes || 'Reset all changes'">
                  <i class="material-icons">refresh</i>
                  <span>{{ translateData?.reset || 'Reset' }}</span>
                </button>
              </div>
              }
            </div>
            <div class="modal__picture-canvas-container">
              <canvas #imageCanvas class="modal__picture-canvas"></canvas>
              <div class="modal__picture-instructions">
                <p>{{ translateData?.picture_drag_instructions || 'Drag to move, handles to resize' }}</p>
              </div>
            </div>
          </div>
          }
        </div>
        }
        @if (modal.options.type === ModalType.TABLE) {
        <div class="modal__table-container">
          <app-table [columns]="modal.options.data?.columns || []" [rows]="modal.options.data?.rows || []">
          </app-table>
        </div>
        }
        @if (modal.options.type === ModalType.SHARE) {
        <div class="modal__share">
          <div class="modal__share-buttons">
            <ul class="icons">
              <a href="#"><i class="fab fa-facebook-f"></i></a>
              <a href="#"><i class="fab fa-twitter"></i></a>
              <a href="#"><i class="fab fa-instagram"></i></a>
              <a href="#"><i class="fab fa-whatsapp"></i></a>
              <a href="#"><i class="fab fa-telegram-plane"></i></a>
            </ul>
          </div>
          <div class="modal__share-copy-lnk">
            <p>{{ translateData?.share_or_copy_link || 'Or copy link' }}</p>
            <button class="modal__share-btn" (click)="copyLink(modal.options.data?.link)">
              <i class="material-icons">content_copy</i>
              {{ translateData?.copy_link_button || 'Copy link' }}
            </button>
          </div>
        </div>
        }
      </div>
    </div>
    @if (modal.options.buttons && modal.options.buttons.length > 0) {
    <div class="modal__footer">
      @for (button of modal.options.buttons; track button) {
      <button [ngClass]="[
                  'modal__button',
                  button.primary ? 'modal__button--primary' : 'modal__button--secondary',
                  button.class || ''
                ]" (click)="onButtonClick(modal, button)">
        {{ resolveText(button.text) }}
      </button>
      }
    </div>
    }
  </div>
</div>
}